import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
  Stack,
  Divider
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PrintIcon from '@mui/icons-material/Print';

const SettingsSummaryCard = ({ 
  title, 
  settings, 
  type = 'admin', // 'admin' or 'business'
  loading = false 
}) => {
  if (loading) {
    return (
      <Card sx={{ minHeight: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography>Loading settings...</Typography>
      </Card>
    );
  }

  const renderAdminSettings = () => (
    <Stack spacing={2}>
      {settings.businessName && (
        <Box>
          <Typography variant="body2" color="text.secondary">
            Business Name
          </Typography>
          <Typography variant="body1" fontWeight={600}>
            {settings.businessName}
          </Typography>
        </Box>
      )}
      
      <Box>
        <Typography variant="body2" color="text.secondary">
          WhatsApp Send Mode
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="h6" fontWeight={600}>
            {settings.whatsappSendAs === 'pdf' ? 'Send as PDF' : 'Send as Link'}
          </Typography>
          <CheckCircleIcon sx={{ color: 'success.main' }} />
        </Box>
      </Box>
      
      {settings.lastUpdated && (
        <Box>
          <Typography variant="body2" color="text.secondary">
            Last Updated
          </Typography>
          <Typography variant="body1">
            {new Date(settings.lastUpdated).toLocaleDateString()}
          </Typography>
        </Box>
      )}
    </Stack>
  );

  const renderBusinessSettings = () => (
    <Stack spacing={2}>
      <Box>
        <Typography variant="body2" color="text.secondary">
          Your Choice
        </Typography>
        <Typography variant="h6" fontWeight={600}>
          {settings.businessDeliveryPlatform}
        </Typography>
      </Box>
      
      <Divider />
      
      <Box>
        <Typography variant="body2" color="text.secondary">
          What Actually Happens
        </Typography>
        <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
          {settings.shouldSendViaWhatsapp && (
            <Chip 
              icon={<WhatsAppIcon />}
              label="WhatsApp" 
              size="small" 
              color="success" 
              variant="outlined"
            />
          )}
          {settings.shouldPrint && (
            <Chip 
              icon={<PrintIcon />}
              label="Print" 
              size="small" 
              color="primary" 
              variant="outlined"
            />
          )}
        </Stack>
      </Box>
      
      <Box>
        <Typography variant="body2" color="text.secondary">
          WhatsApp Mode
        </Typography>
        <Typography variant="body1">
          {settings.effectiveWhatsappSendAs === 'pdf' ? 'Send as PDF' : 'Send as Link'}
        </Typography>
      </Box>
    </Stack>
  );

  return (
    <Card sx={{ height: '100%', minHeight: 200 }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <SettingsIcon color="primary" />
          <Typography variant="h6" fontWeight={600}>
            {title}
          </Typography>
        </Box>
        
        {type === 'admin' ? renderAdminSettings() : renderBusinessSettings()}
      </CardContent>
    </Card>
  );
};

export default SettingsSummaryCard; 